import styled from 'styled-components'

const TypoBase = styled.div`
	font-family: Century Gothic;
	font-style: normal;
	align-items: center;
	letter-spacing: 0.02em;
	line-height: 110%;
`

const Title = styled(TypoBase)`
	font-weight: normal;
	font-size: 32px;
	color: #7c7184;
`

const H1 = styled(TypoBase)`
	font-weight: bold;
	font-size: 16px;
	color: #44344f;
`

const H2 = styled(TypoBase)`
	font-weight: bold;
	font-size: 14px;
	color: #44344f;
`

const Subheading = styled(TypoBase)`
	font-weight: normal;
	font-size: 12px;
	line-height: 150%;
	color: #a8a4b1;
`

export { Title, H1, H2, Subheading }
